import {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {TeamRoster} from './BotComponents';

const {FiLayers, FiUsers, FiCopy, FiCheck, FiTarget} = FiIcons;

export default function AdsBriefsSidebar({state, team, bots}) {
  const [tab, setTab] = useState('briefs'); // 'briefs' | 'roster'
  const [copiedIndex, setCopiedIndex] = useState(null);

  const briefs = state.adCampaignBriefs || [];

  function copyText(text, key) {
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(text);
    setCopiedIndex(key);
    setTimeout(() => setCopiedIndex(null), 2000);
  }

  return (
    <aside className="panel chat-module-sidebar">
      <div className="sidebar-tab-header">
        <button
          type="button"
          className={`sidebar-tab-btn ${tab === 'briefs' ? 'active' : ''}`}
          onClick={() => setTab('briefs')}
        >
          <SafeIcon icon={FiLayers} />
          <span>Campaign Briefs ({briefs.length})</span>
        </button>
        <button
          type="button"
          className={`sidebar-tab-btn ${tab === 'roster' ? 'active' : ''}`}
          onClick={() => setTab('roster')}
        >
          <SafeIcon icon={FiUsers} />
          <span>Team Roster</span>
        </button>
      </div>

      {tab === 'roster' ? (
        <TeamRoster team={team} bots={bots} />
      ) : (
        <div className="ads-briefs-list">
          <div className="section-heading">
            <div>
              <span className="eyebrow">Creative &amp; Copy</span>
              <h3>Ad Campaign Briefs</h3>
            </div>
          </div>

          {briefs.length === 0 ? (
            <div className="empty-copy">
              <p>No briefs saved yet.</p>
              <small>Ask Mateo (Growth Lead) and Zoe (Copywriter) to create concepts, then click “Save as Campaign Brief”.</small>
            </div>
          ) : (
            briefs.map((brief) => (
              <article className="ads-brief-card" key={brief.id}>
                <div className="inline spread">
                  <b>{brief.title}</b>
                  <span className={`status ${brief.status || 'draft'}`}>
                    {brief.status || 'draft'}
                  </span>
                </div>

                {brief.targetAudience && (
                  <div className="brief-audience">
                    <SafeIcon icon={FiTarget} />
                    <small><b>Audience:</b> {brief.targetAudience}</small>
                  </div>
                )}

                {brief.keyMessage && (
                  <p className="brief-key-message">“{brief.keyMessage}”</p>
                )}

                {/* Comparable Copy Variants */}
                {brief.variants?.length > 0 && (
                  <div className="copy-variants-wrap">
                    <span className="eyebrow" style={{fontSize: '10px'}}>Comparable copy variants</span>
                    <div className="copy-variants-grid">
                      {brief.variants.map((variant, idx) => {
                        const copyKey = `${brief.id}_${idx}`;
                        const isCopied = copiedIndex === copyKey;
                        return (
                          <div className="copy-variant-card" key={idx}>
                            <p>{variant}</p>
                            <button
                              type="button"
                              className="copy-btn icon-button"
                              onClick={() => copyText(variant, copyKey)}
                              title="Copy text to clipboard"
                              aria-label="Copy variant text"
                            >
                              <SafeIcon icon={isCopied ? FiCheck : FiCopy} />
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </article>
            ))
          )}
        </div>
      )}
    </aside>
  );
}
